<div class="main">
    <div class="header-left">
        <p-breadcrumb [model]="breadcrumbItems"
            styleClass="app-breadcrumb">
            <ng-template pTemplate="item" let-item>
                <a>{{item.label}}</a>
            </ng-template>
            <ng-template #separator><span class="separator"> / </span></ng-template>

        </p-breadcrumb>

    </div>
    <div class="header-right actions">
        <ng-container *ngFor="let button of actionItems?.redirectButtons ?? []">
            <div class="button-wrapper" *ngIf="isButtonVisible(button)">
                <button class="outlined-button flex items-center" (click)="navigateTo(button.route)">
                    <i class="pi pi-plus-circle button-icon "></i>
                    <span class="text">{{ button.label }}</span>
                </button>
            </div>
        </ng-container>

        <div class="button-wrapper" *ngFor="let button of actionItems?.actionButtons ?? []">
            <button class="outlined-button flex items-center" (click)="executeAction(button.action)">
                <i [class]="'button-icon ' + (button.icon || 'pi pi-download')"></i>
                <span class="text">{{ button.label }}</span>
            </button>
        </div>

        <div *ngIf="actionItems?.showBulkUpload ?? false" class="button-wrapper">
            <button class="outlined-button  flex items-center " (click)="openBulkUpload()">
                <i class="pi pi-upload button-icon "></i>
                <p class="text">Bulk Upload</p>
            </button>
        </div>

        <!-- Toolbar Actions (showInToolbar: true) - shown as separate icon buttons -->
        <ng-container *ngFor="let action of toolbarActions">
            <div class="icon-wrapper">
                <button 
                    class="p-button-text p-button-rounded toolbar-action-btn"
                    pButton
                    [icon]="action.icon || 'pi pi-cog'"
                    [disabled]="action.disabled"
                    (click)="onPageActionClick(action)"
                    [pTooltip]="action.tooltip || action.label"
                    tooltipPosition="bottom">
                </button>
            </div>
        </ng-container>

        <div *ngIf="actionItems?.showFavorite !== false" class="icon-wrapper">
            <i class="pi pi-star icon cursor-pointer"></i>
        </div>

        
        <!-- Page Actions Popover (Three-dots menu) - only shows non-toolbar actions -->
        <div *ngIf="dropdownActions.length > 0" class="icon-wrapper actions-menu-trigger">
            <button 
            class="p-button-text p-button-rounded actions-trigger"
            pButton
            icon="pi pi-ellipsis-v"
            (click)="actionsPopover.toggle($event)"
            pTooltip="Actions"
            tooltipPosition="bottom">
        </button>
        
        <p-popover #actionsPopover styleClass="page-actions-popover">
            <div class="actions-menu">
                <button 
                *ngFor="let action of dropdownActions"
                class="action-item"
                [class.action-danger]="action.severity === 'danger'"
                [class.action-success]="action.severity === 'success'"
                [class.action-warn]="action.severity === 'warn'"
                [class.action-disabled]="action.disabled"
                [disabled]="action.disabled"
                [pTooltip]="action.tooltip || ''"
                tooltipPosition="left"
                (click)="onPageActionClick(action)">
                <i *ngIf="action.icon" [class]="action.icon"></i>
                <span>{{ action.label }}</span>
            </button>
        </div>
    </p-popover>
</div>
<div *ngIf="actionItems?.showBack !== false" class="back-button cursor-pointer" (click)="goBack()">
    <i class="pi pi-arrow-left arrow"></i>
    <span class="text">Back</span>
</div>

    </div>
</div>

<app-bulk-upload
    [(visible)]="showBulkUploadDialog"
    [module]="currentModule"
    [title]="'Bulk Upload'"
    [formTemplateId]="formTemplateId"
    [tabs]="bulkUploadTabs"
    (uploadSuccess)="onBulkUploadSuccess($event)"
    (uploadError)="onBulkUploadError($event)">
</app-bulk-upload>